import { Fragment } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import styles from "./OurServices.module.scss";
// import useScreenSize from "../hooks/useScreenSize";
import image1 from "../assets/images/home/services/image-1.png";
import image2 from "../assets/images/home/services/image-2.png";
import image3 from "../assets/images/home/services/image-3.png";
import image4 from "../assets/images/home/services/image-4.png";
import useLang from "hooks/useLang";

const OurServices = () => {
  // const { width, breakpoints } = useScreenSize();
  const { lang } = useLang();

  return (
    <Fragment>
      <section className={["section"].join(" ")} id="our-services">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="sec-hd-custom">
                <h1 className="sec-title">{lang.our_services.section_title}</h1>
              </div>
            </Col>
          </Row>
          <Row>
            <Container>
              <Row className="justify-content-center">
                <section>
                  <Container>
                    <Row className="align-items-center">
                      <Col lg={6}>
                        <div className="work-pra">
                          <h2>{lang.our_services.service_1_title}</h2>
                          <p className="text-muted">
                            {lang.our_services.service_1_detail}
                          </p>
                          <p className="text-muted">
                            {lang.our_services.service_1_include}
                          </p>
                          <ol type="1" className="text-muted">
                            {lang.our_services.service_1_list.map((list) => (
                              <li>{list}</li>
                            ))}
                          </ol>
                          <Link
                            to="https://api.whatsapp.com/send?phone=6281188030203&amp;text=Halo%20Admin%2C%20saya%20sedang%20membutuhkan%20jasa%20perpajakan.%20Apakah%20boleh%20dibantu%3F"
                            target="_blank"
                          >
                            <h3 className={styles.readMore}>
                              {lang.footer.cta_1}{" "}
                              <i className={`uil uil-arrow-right`} />
                            </h3>
                          </Link>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <img
                          src={image1}
                          alt=""
                          className="fill-available our-services-home-img"
                        />
                      </Col>
                    </Row>
                  </Container>
                </section>
              </Row>
            </Container>
            <Container className="our-services-home-container">
              <Row className="justify-content-center">
                <section>
                  <Container>
                    <Row
                      style={{ flexDirection: "row-reverse" }}
                      className="align-items-center"
                    >
                      <Col lg={6}>
                        <div className="work-pra">
                          <h2>{lang.our_services.service_2_title}</h2>
                          <p className="text-muted">
                            {lang.our_services.service_2_detail}
                          </p>
                          <p className="text-muted">
                            {lang.our_services.service_2_include}
                          </p>
                          <ol type="1" className="text-muted">
                            {lang.our_services.service_2_list.map((list) => (
                              <li>{list}</li>
                            ))}
                          </ol>
                          <Link
                            to="https://api.whatsapp.com/send?phone=6281188030203&amp;text=Halo%20Admin%2C%20saya%20sedang%20membutuhkan%20jasa%20perpajakan.%20Apakah%20boleh%20dibantu%3F"
                            target="_blank"
                          >
                            <h3 className={styles.readMore}>
                              {lang.footer.cta_1}{" "}
                              <i className={`uil uil-arrow-right`} />
                            </h3>
                          </Link>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <img
                          src={image2}
                          alt=""
                          className="fill-available our-services-home-img"
                        />
                      </Col>
                    </Row>
                  </Container>
                </section>
              </Row>
            </Container>
            <Container className="our-services-home-container">
              <Row className="justify-content-center">
                <section>
                  <Container>
                    <Row className="align-items-center">
                      <Col lg={6}>
                        <div className="work-pra">
                          <h2>{lang.our_services.service_3_title}</h2>
                          <p className="text-muted">
                            {lang.our_services.service_3_detail}
                          </p>
                          <p className="text-muted">
                            {lang.our_services.service_3_include}
                          </p>
                          <ul className="text-muted">
                            {lang.our_services.service_3_list.map((list) => (
                              <li>{list}</li>
                            ))}
                          </ul>
                          <Link
                            to="https://api.whatsapp.com/send?phone=6281188030203&amp;text=Halo%20Admin%2C%20saya%20sedang%20membutuhkan%20jasa%20perpajakan.%20Apakah%20boleh%20dibantu%3F"
                            target="_blank"
                          >
                            <h3 className={styles.readMore}>
                              {lang.footer.cta_1}{" "}
                              <i className={`uil uil-arrow-right`} />
                            </h3>
                          </Link>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <img
                          src={image3}
                          alt=""
                          className="fill-available our-services-home-img"
                        />
                      </Col>
                    </Row>
                  </Container>
                </section>
              </Row>
            </Container>
            <Container className="our-services-home-container">
              <Row className="justify-content-center">
                <section>
                  <Container>
                    <Row
                      style={{ flexDirection: "row-reverse" }}
                      className="align-items-center"
                    >
                      <Col lg={6}>
                        <div className="work-pra">
                          <h2>{lang.our_services.service_4_title}</h2>
                          <p className="text-muted">
                            {lang.our_services.service_4_detail}
                          </p>
                          <p className="text-muted">
                            {lang.our_services.service_4_include}
                          </p>
                          <ul className="text-muted">
                            {lang.our_services.service_4_list.map((list) => (
                              <li>{list}</li>
                            ))}
                          </ul>
                          <Link
                            to="https://api.whatsapp.com/send?phone=6281188030203&amp;text=Halo%20Admin%2C%20saya%20sedang%20membutuhkan%20jasa%20perpajakan.%20Apakah%20boleh%20dibantu%3F"
                            target="_blank"
                          >
                            <h3 className={styles.readMore}>
                              {lang.footer.cta_1}{" "}
                              <i className={`uil uil-arrow-right`} />
                            </h3>
                          </Link>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <img
                          src={image4}
                          alt=""
                          className="fill-available our-services-home-img"
                        />
                      </Col>
                    </Row>
                  </Container>
                </section>
              </Row>
            </Container>
          </Row>
        </Container>
      </section>
    </Fragment>
  );
};

export default OurServices;
